module.exports = __webpack_public_path__ + "media/hallBgm.001d87b6.mp3";